<template>
	<div class="data-section">
		<h4>{{ title }} ({{ items.length }})</h4>
		<div class="table-wrapper">
			<table class="detail-table">
				<thead>
					<tr>
						<th v-for="column in columns" :key="column.key">
							{{ column.label }}
						</th>
						<th>Details</th>
					</tr>
				</thead>
				<tbody>
					<template v-for="(item, index) in items" :key="index">
						<tr>
							<td v-for="column in columns" :key="column.key">
								{{ formatCellValue(item, column) }}
							</td>
							<td>
								<button class="btn-expand" @click="$emit('toggle-details', index)">
									{{ expandedIndex === index ? '−' : '+' }}
								</button>
							</td>
						</tr>
						<tr v-if="expandedIndex === index" class="detail-row">
							<td :colspan="columns.length + 1">
								<div class="detail-content">
									<slot name="details" :item="item" :index="index"></slot>
								</div>
							</td>
						</tr>
					</template>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ExpandableDataTable',
	props: {
		title: {
			type: String,
			required: true
		},
		items: {
			type: Array,
			required: true
		},
		columns: {
			type: Array,
			required: true,
			// Each column should have: { key, label, formatter? }
		},
		expandedIndex: {
			type: [Number, null],
			default: null
		}
	},
	emits: ['toggle-details'],
	methods: {
		formatCellValue(item, column) {
			if (column.formatter) {
				return column.formatter(item);
			}

			// Handle nested properties with dot notation (e.g., "provider.name")
			const keys = column.key.split('.');
			let value = item;
			for (const key of keys) {
				value = value?.[key];
			}

			return value || '-';
		}
	}
};
</script>
